import { render, staticRenderFns } from "./Personalreport.vue?vue&type=template&id=9421023c&scoped=true&"
import script from "./Personalreport.vue?vue&type=script&lang=js&"
export * from "./Personalreport.vue?vue&type=script&lang=js&"
import style0 from "./Personalreport.vue?vue&type=style&index=0&id=9421023c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9421023c",
  null
  
)

export default component.exports